import React, { Component } from "react";
import style from "./InventoryAuditTrail.module.css";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { fetchAuditTrailList } from "../../redux";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import moment from "moment";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class InventoryAuditTrail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isEditMode: "",
      isDataFetched: false,
      inventoryAuditList: []
    };
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async()=> {
    document.title = 'Inventory Audit Trail - TechToMedix';
    await this.props.fetchAuditTrailList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.auditListData &&
      this.props.auditListData.auditList &&
      this.props.auditListData.auditList.inventorylog){
      this.setState({
        inventoryAuditList: this.props.auditListData.auditList.inventorylog
      })
    }
    setTimeout(() => {
      if (this.props.auditListData.auditList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  }

  callInventoryAuditList = async() => {
    this.setState({
      inventoryAuditList: [],
    });
    await this.props.fetchAuditTrailList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );   
     if(!this.props.auditListData.loading){
      this.setState({
        inventoryAuditList: this.props.auditListData.auditList.inventorylog
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callInventoryAuditList();
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callInventoryAuditList();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callInventoryAuditList();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  render() {
    const auditList = this.props.auditListData.auditList;

    return (
      <div className={`inventory-audit ${style.inventoryAuditMainWrapper}`}>
        <div className="row">
          <div className="col-lg-7">
            <h3>Inventory Audit Trail</h3>
          </div>
          <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
        </div>
        <div className="row">
        <div className="col-lg-12 intro-text">
            <p className="mb-4">
              This is the log of the products when added or left the system. The
              dates will be updated accordingly.This is the log of the products
              when added or left the system. The dates will be updated
              accordingly.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <BootstrapTable
            remote={true}
              bordered={false}
              data={this.state.inventoryAuditList}
              version="4"
              search={false}
              pagination
              fetchInfo={{
                dataTotalSize: this.props.auditListData.auditList.total,
              }}
              options={{
                sortName: this.state.sortName,
                sortOrder: this.state.sortOrder,
                onSortChange: this.onSortChange,
                onSearchChange: this.onSearchChange,
                sizePerPage: 10,
                page: this.state.page,
                onPageChange: this.onPageChange,
                noDataText: this.setLoader(),
              }}
            >
              <TableHeaderColumn 
              dataField="name" 
              width="20%"
              isKey 
              dataSort={true}>
                Name
              </TableHeaderColumn>
              <TableHeaderColumn 
              dataField="unique_code"
              width="20%" 
              dataSort={true}>
                Unique Code
              </TableHeaderColumn>
              <TableHeaderColumn
               dataField="user_name" 
               width="20%"
               dataSort={true}>
                User (changed by)
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="disposal_date"
                width="20%"
                dataSort={true}
                dataFormat={dateFormatter}
              >
                Disposal Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="loading_date"
                width="20%"
                dataSort={true}
                dataFormat={dateFormatter}
              >
                Loading Date
              </TableHeaderColumn>

              {/* <TableHeaderColumn
                dataField="actions"
                dataFormat={this.actionsFormatter.bind(this)}
                width="20%"
              >
                Actions
              </TableHeaderColumn> */}
            </BootstrapTable>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auditListData: state.auditList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAuditTrailList: (searchKey, sortBy, page) =>
      dispatch(fetchAuditTrailList(searchKey, sortBy, page)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAuditTrail);
